import { intersectionObserve } from "./_intersection-observer";

window.addEventListener("load", function () {
	const nextDepartureElements = document.querySelectorAll(
		".next-departure-container"
	);
	observeNextDepartureElements(nextDepartureElements);
});

export function observeNextDepartureElements(elements) {
	intersectionObserve(elements, 0, 0, (element, intersectionRatio) => {
		(function (el) {
			if (intersectionRatio > 0) {
				getNextDepartures(el);
			}
		})(element);
	});
}

function formatTime(time, lang) {
	if (lang === "nb-NO") {
		return time.toLocaleTimeString("nb-NO", {
			hour: "2-digit",
			minute: "2-digit",
		});
	} else {
		return time.toLocaleTimeString("en-US", {
			timeStyle: "short",
		});
	}
}

function formatDate(date, lang) {
	if (lang === "nb-NO") {
		return date.toLocaleDateString("no-NB", {
			day: "numeric",
			month: "long",
		});
	} else {
		return date.toLocaleDateString("en-US", {
			day: "numeric",
			month: "long",
		});
	}
}

function getNextDepartures(element) {
	if (element.classList.contains("next-departure-loaded")) {
		return;
	}
	const departureTextField = element.querySelector(".next-departure");
	const departurePreTextField = element.querySelector(
		".next-departure-pre-text"
	);
	const loader = element.querySelector(".loader");
	const todayDateString = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
	const todayDateTime = new Date(); // Get today's date and time

	element.classList.add("next-departure-loaded");

	const productCode = element.getAttribute("data-iticket-productcode");
	const locationCode = element.getAttribute("data-iticket-locationcode");
	jQuery.ajax({
		type: "POST",
		url: rodne_scripts.ajax_url,
		data: {
			action: "get_product_departures",
			product_code: productCode,
			location_code: locationCode,
		},
		success: function (output) {
			let departures = output["departures"] || [];

			// Filter timestamps
			const timestamps = departures.map(departure => departure["datetime"]);
			departures = departures.filter((departure, index) => {
				// 1. We only want timestamps in the future
				// 2. We only want one departure for each timestamp.
				// 3. If the departure is from a fallback API, we only want the first departure (the rest cannot be
				//    trusted to be real departures)
				return timestamps.indexOf(departure["datetime"]) === index &&
					new Date(departure["datetime"]) >= todayDateTime &&
					(!departure["isFallback"] || (departure["isFallback"] && index === 0));
			});

			if (departures.length > 0) {
				// Group departures by date, i.e. {"2025-06-01": [{"datetime": ..."}, ...], "2025-06-02": []}
				const departuresByDate = departures.reduce((acc, departure) => {
					const date = new Date(departure["datetime"]).toISOString().split("T")[0];
					acc[date] = acc[date] || [];
					acc[date].push(departure);
					return acc;
				}, {});


				const firstAvailableDate = Object.keys(departuresByDate)[0];
				const displayDates = [firstAvailableDate];

				const isFirstAvailableDateFull = departuresByDate[firstAvailableDate].filter(departure => {
					return departure["availableCapacity"] > 0
				}).length === 0;

				if (isFirstAvailableDateFull) {
					// If the first date is full, loop over the remaining dates to find available capacity
					const dates = Object.keys(departuresByDate);
					for (let i = 1; i < dates.length; i++) {
						const departures = departuresByDate[dates[i]];
						const isFull = departures.filter(departure => {
							return departure["availableCapacity"] > 0
						}).length === 0;

						displayDates.push(dates[i]);

						if (!isFull) {
							break;
						}
					}
				}

				const lang = document.documentElement.lang;

				const dateTexts = displayDates.map(date => {
					const departures = departuresByDate[date];

					let text = "";
					const isToday = date === todayDateString;

					if (isToday) {
						text = lang === "nb-NO" ? "I dag kl. " : "Today at ";
					} else {
						text =
							formatDate(new Date(date), lang) +
							(lang === "nb-NO" ? " kl. " : " at ");
					}

					// Format all the departure times
					const times = departures.map((departure) => {
						return formatTime(new Date(departure["datetime"]), lang) +
							(departure["availableCapacity"] === 0 ? " " + (lang === "nb-NO" ? "(fullt)" : "(full)") : "");
					});

					// Join the n-1 times with a comma
					text += times
						.slice(0, Math.max(times.length - 1, 1))
						.join(", ");

					// Add the last departure time with a "and" separator
					if (times.length > 1) {
						text +=
							(lang === "nb-NO" ? " og " : " and ") +
							times[times.length - 1];
					}

					return text;
				});

				departureTextField.innerHTML = dateTexts.join("<br>");

				// If there are multiple departures, change the pre-text to plural
				if (departuresByDate[firstAvailableDate].length > 1 || displayDates.length > 1) {
					departurePreTextField.querySelector('span').innerHTML =
						departurePreTextField.dataset.multipleDepaturesText;
				}
			} else {
				const noFutureDepartures = element.querySelector(
					".no-future-departures"
				);
				const departureTextField = element.querySelector(
					".next-departure-pre-text"
				);

				const nextDepartureTextField =
					element.querySelector(".next-departure");
				noFutureDepartures.classList.remove("hidden");
				departureTextField.classList.add("hidden");
				nextDepartureTextField.classList.add("hidden");
			}

			loader.classList.add("hidden");
		},
	});
}
